import React, { useEffect, useRef } from "react";
import { ReferenceInput, SelectInput, required } from "react-admin";
import { Grid } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { employeeRequests } from "api/employeeApi";
import { BusinessTripTypes } from "utils/constants";

const DomesticTripCategoryInput = () => {
  const { setValue } = useFormContext();
  const businessTripType = useWatch({ name: "businessTripType" });
  const isInternal = businessTripType === BusinessTripTypes.Internal;
  const isFirstRender = useRef(true);

  // The backend rejects a subtype on an international trip.
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!isInternal) setValue("domesticTripCategory", null);
  }, [isInternal, setValue]);

  if (!isInternal) return null;

  return (
    <Grid
      item
      xs={12}
      md={6}
      lg={4}
      sx={{ ml: 2 }}
    >
      <ReferenceInput
        source="domesticTripCategory"
        reference={employeeRequests.getDomesticTripCategoriesSelect()}
      >
        <SelectInput
          fullWidth
          label="Тип вътрешна командировка"
          optionText="nameBg"
          validate={required()}
          SelectProps={{ MenuProps: { disableScrollLock: true } }}
        />
      </ReferenceInput>
    </Grid>
  );
};

export default DomesticTripCategoryInput;
